import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

/**
 * Returns the item id of the active rendering.
 */
const useItemId = (): string | undefined => {
  const context = useSitecoreContext();
  return context?.sitecoreContext?.itemId as string;
};

export default useItemId;
